import Vue from 'vue';
// import AreaCodeHolder from '@/common/areaCodeHolder.js';
export default {
  // 采购项目列表的状态查询
  getTransctionListStatus (type) {
    return Vue.axios.get('/api/v1.0/chanquan/project/projectListStatus?type=' + type);
  },
  // 采购项目列表
  getTradeProList (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/selectTradePro', payload);
  },
  // 获取我的转出项目列表
  getRollOutProjectList (pageNum, pageSize) {
    return Vue.axios.get('/api/v1.0/chanquan/center/getProjectListByUser/' + pageNum + '/' + pageSize);
  },
  // 我的转出项目详情
  getRollOutProjectDetail (params) {
    return Vue.axios.get('/api/v1.0/chanquan/project/echo', { params });
  },
  // 校验当前登录人是否报名
  checkCurrentUserSign (projectId) {
    return Vue.axios.get('/api/v1.0/chanquan/project/checkCurrentUserSign?projectId=' + projectId);
  },
  // 校验当前登录人是否报名
  checkCurrentUserSignForUnlogin (projectId) {
    return Vue.axios.get('/api/v1.0/chanquan/project/checkCurrentUserSignForUnlogin?projectId=' + projectId);
  },
  // 转让项目详情
  getTransProjectDetail (params) {
    return Vue.axios.get('/api/v1.0/chanquan/project/echo', { params });
  },
  // 采购项目报名
  purchaseProjectSignUp (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/bid/sign', payload);
  },
  // 立即报名保存的接口
  atonceSign (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/signUpSave', payload);
  },
  // 获取热推项目集合
  selectIndexRecommendProject (limitNum) {
    // const length = AreaCodeHolder.getInstance().areaCode.length;
    let params = { limitNum };
    // if (length === 4) {
    //   params = {
    //     limitNum,
    //     county: AreaCodeHolder.getInstance().areaCode
    //   };
    // } else if (length === 6) {
    //   params = {
    //     limitNum,
    //     township: AreaCodeHolder.getInstance().areaCode
    //   };
    // } else 
    if (length === 2) {
      params = {
        limitNum: 4
        // city: AreaCodeHolder.getInstance().areaCode
      };
    }
    return Vue.axios.post('/api/v1.0/chanquan/project/selectIndexRecommendProject', params);
  },
  // 转让-项目详情附件下载
  getDownloadAttachmentUrl (projectType, projectSubType) {
    return Vue.axios.get('/api/v1.0/chanquan/project/getDownloadAttachmentUrl/' + projectType + '/' + projectSubType);
  },
  // 获取合同下载和预览地址
  getProjectContractUrl (params) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/getContractUrlByProjectIdV2', { params: params });
  },
  //  获取项目子类型
  getProjectSubType (projectType) {
    return Vue.axios.get('/api/v1.0/chanquan/project/getProjectSubType/' + projectType);
  }
};
